import { post } from '@/request';

const deptApi = {
  okrTree(data) {
    return post('/gt/dept/zlb/okrTree', data);
  },
  list(data) {
    return post('/gt/dept/zlb/list', data);
  },
  one(data) {
    return post('/gt/dept/zlb/one', data);
  }
};
export default deptApi;
